import AbstractModel from './utils/abstractModel'
import types from './utils/types'

class CurrentSubscription extends AbstractModel {
  /**
   * @type {date | null}
   */
  expiresAt

  /**
   * @type {integer, null}
   */
  corporateId

  /**
   * @type {string, null}
   */
  corporateKey

  /**
   * @type {string, null}
   */
  corporateName

  /**
   * @type {string}
   */
  status

  static STATUSES = {
    ACTIVE: 'active',
    EXPIRED: 'expired',
    EXPIRING: 'expiring',
    UNKNOWN: 'unknown',
  }

  constructor(json) {
    super(json)
    this.expiresAt = this.parseDate(json.expires_at)
    this.corporateId = json.corporate_id
    this.corporateKey = json.corporate_key
    this.corporateName = json.corporate_name
    this.status = json.status

    this.validate()
  }

  validate() {
    this.assertType('expiresAt', [types.DATE, types.NULL])
    this.assertType('corporateId', [types.NUMBER, types.NULL])
    this.assertType('corporateKey', [types.STRING, types.NULL])
    this.assertType('corporateName', [types.STRING, types.NULL])
    this.assertType('status', [types.STRING])
  }

  get isExpired() {
    return this.status === this.constructor.STATUSES.EXPIRED
  }
}

export default CurrentSubscription
